import { Component, OnInit } from '@angular/core';
import { User } from '../classes/User';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

	user: User;
	err = "";
	loading = true;
	editVenmo: boolean;
  editName: boolean;

  venueList: VenueListItem[] = [];

	constructor(private authServ: AuthService, private userServe: UserService) { }

	ngOnInit(): void {
		this.authServ.getHostDetail()
			.subscribe((res: any) => {
				this.user = new User(res);
        this.getVenueList();
			})
  }

  getVenueList() {
    this.userServe.getUserVenues()
      .pipe(finalize(() => this.loading = false))
      .subscribe((res: any) => {
        this.venueList = res;
        console.log(this.venueList);
      })
  }

	updateUser(update: any) {
		this.loading = true
		this.authServ.updateUser(update)
			.subscribe(res => {
				this.user = new User(res);
				localStorage.setItem("user_detail", JSON.stringify(this.user))
				this.loading = false;
				this.editVenmo = false;
				this.editName = false;
			},
			err => {
				this.loading = false;
				this.err = err.error.detail;
			})
	}

}
